import { useState, useEffect } from "react";

export default function Stats() {
  const stats = [
    { number: 20, label: "Projects Completed", icon: "🚀", suffix: "+" },
    { number: 10, label: "Happy Clients", icon: "😊", suffix: "+" },
    { number: 24, label: "Support Available", icon: "💡", suffix: "/7" },
  ];

  return (
    <section className="py-16 px-4 bg-black relative overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-green-500/5 to-transparent"></div>
      
      <div className="relative max-w-6xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-green-500/10 border border-green-500/20 rounded-full text-green-400 text-xs font-semibold tracking-wider uppercase mb-3">
            Our Numbers
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-white">
            We Deliver Results
          </h2>
        </div>

        {/* Stats Grid */}
<div className="grid grid-cols-3 gap-4 sm:gap-6">
  {stats.map((s, i) => (
    <div
      key={i}
      className="relative group"
    >
      <div className="absolute inset-0 bg-gradient-to-r from-green-500/10 to-emerald-500/10 rounded-xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
      
      <div className="relative bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-xl p-4 sm:p-6 text-center hover:border-green-500/30 transition-all duration-300">
        {/* Icon */}
        <div className="text-2xl sm:text-3xl mb-2">{s.icon}</div>
        
        {/* Number */}
        <div className="flex items-center justify-center gap-0.5">
          <span className="text-xl sm:text-2xl md:text-3xl font-extrabold text-white">
            {s.number}
          </span>
          <span className="text-base sm:text-lg font-bold text-green-400">
            {s.suffix}
          </span>
        </div>
        
        {/* Label */}
        <p className="mt-1 text-gray-400 text-[10px] sm:text-xs md:text-sm">
          {s.label}
        </p>

        {/* Progress Bar */}
        <div className="mt-2 h-0.5 w-full bg-gray-800 rounded-full overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-green-400 to-emerald-300 rounded-full transition-all duration-1000"
            style={{ width: `${(s.number / 25) * 100}%` }}
          ></div>
        </div>
      </div>
    </div>
  ))}
</div>
      </div>
    </section>
  );
}